var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSvgDoor = function SvgSvgDoor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.5 14.625a1 1 0 0 1-.13-.011 1.126 1.126 0 0 1-.983-.982.7.7 0 0 1 0-.262c.06-.513.47-.922.983-.983a.8.8 0 0 1 .26 0c.513.061.923.47.983.983a.7.7 0 0 1 0 .262c-.06.513-.47.922-.983.982a1 1 0 0 1-.13.011"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3 24a2.25 2.25 0 0 1-2.25-2.25v-12A9.78 9.78 0 0 1 7.327.533a9.7 9.7 0 0 1 6.346 0A9.78 9.78 0 0 1 20.25 9.75v.75h2.25a.75.75 0 0 1 0 1.5h-2.25v6h2.25a.75.75 0 0 1 0 1.5h-2.25v2.25A2.25 2.25 0 0 1 18 24zm15-1.5a.75.75 0 0 0 .75-.75V19.5H18a.75.75 0 0 1 0-1.5h.75v-6H18a.75.75 0 0 1 0-1.5h.75v-.75a8.24 8.24 0 0 0-4.5-7.347V22.5zm-5.25 0V1.813a8.2 8.2 0 0 0-4.5 0V22.5zm-6-20.097a8.24 8.24 0 0 0-4.5 7.347v12c0 .414.336.75.75.75h3.75z"
  })));
};
export default SvgSvgDoor;